// /demo: Book a demo (handoff design/website/Demo.dc.html), a request form
// that posts the beta signup with kind "demo" (OD-P15, B6). No calendar and
// no availability slots: the visitor says which days and times suit, and is
// emailed to pick one. Open to anyone, signed in or not.
import { createFileRoute } from '@tanstack/react-router';
import { DemoPage } from '@/features/site/demo/DemoPage';

export const Route = createFileRoute('/_site/demo')({
  component: DemoPage,
});
